

































import { Component, Vue } from 'vue-property-decorator';
import {GeneralService} from '../services/general-service';
import ProgramLevel from '../components/ProgramLevel.vue';
import config from '../services/api-config';
import router from '../router';
import AuthService from '../services/auth-service';

@Component({
  components: {
      'program-level': ProgramLevel
  },
})

export default class ExamResult extends Vue {
    private service = new GeneralService();
    private auth = new AuthService();
    private fees: any = [];
    private filter = '';
    private nextChallan = -1;
    private fields = [       
        {key: "index", label: "Sr. No."},
        {key: "challan_Number", label: "Challan Number"},
        {key: "chalan_type_name", label: "Challan Type"},
        {key: "class_ID", label: "Class"},
        {key: "amount", label: "Amount"},
        {key: "iNstallment", label: "Installment"},
        {key: "due_date", label: "Due Date"},
        {key: 'paynow', label: 'Paid Date'}
      ];
    

    showChallan(index) {
        window.open( 
              "https://my.hadaf.edu.pk/challan/#/" + this.fees[index].challan_Number, "_blank"); 
    }

    get feesWithIndex() {
      return this.fees.map((item, i) => ({ ...item, _rowIndex: i + 1 }));
    }

    filterFees(row: any, filter: string) {
      const f = filter.toLowerCase();
      return (
        String(row._rowIndex).includes(f) ||
        (row.challan_Number || '').toString().toLowerCase().includes(f) ||
        (row.chalan_type_name || '').toLowerCase().includes(f) ||
        (row.class_ID || '').toLowerCase().includes(f)
      );
    }

    payNow() {
        window.open( 
              "https://pgc.paymentprocessingpage.com", "_blank"); 
    }
   

    mounted (){
        let username = this.auth.session.userName.split('@')[0];
        this.service
          .getFeesEMS(
              username,
              localStorage[config.userInfoEMS]
          )
          .then(result => {
              this.fees = result.data.Data;
              let check = false;
              for (let i = 0; i<this.fees.length; i++){
                if ((check && this.fees[i].chalan_type_name == 'Education') || !this.fees[i].allowButton){
                  this.fees[i].received_date = 'Not Available';
                }
                
                if (this.fees[i].received_date == '01-01-1900' && this.fees[i].chalan_type_name == 'Education'){
                  this.nextChallan = this.fees[0].challan_Number;
                  check = true;
                }
              }
        });
    }
}
